import Navigation from "@/components/Navigation";
import { Syringe, Droplets } from "lucide-react";

const Fillers = () => {
  return (
    <div className="min-h-screen bg-white">
      <Navigation />
      <div className="pt-24 px-6">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-12 mb-12">
            <div>
              <h1 className="text-4xl md:text-5xl font-serif mb-6">Dermal Fillers</h1>
              <p className="text-lg mb-6 text-gray-700">
                Our premium dermal filler treatments restore volume and enhance facial contours using FDA-approved products. 
                Experience natural-looking results that help you achieve your aesthetic goals.
              </p>
              <div className="space-y-6">
                <div className="flex items-start gap-4">
                  <Droplets className="w-6 h-6 text-primary mt-1" />
                  <div>
                    <h3 className="text-xl font-semibold mb-2">Natural Volume Enhancement</h3>
                    <p className="text-gray-600">Restore youthful volume to cheeks, lips, and other facial areas with natural-looking results.</p>
                  </div>
                </div>
                <div className="flex items-start gap-4">
                  <Syringe className="w-6 h-6 text-primary mt-1" />
                  <div>
                    <h3 className="text-xl font-semibold mb-2">Premium Products</h3>
                    <p className="text-gray-600">We use only FDA-approved fillers administered by experienced professionals.</p>
                  </div>
                </div>
              </div>
              <div className="mt-8">
                <h3 className="text-xl font-semibold mb-4">Treatment Areas</h3>
                <ul className="list-disc list-inside space-y-2 text-gray-700">
                  <li>Cheeks and midface</li>
                  <li>Lips and lip lines</li>
                  <li>Nasolabial folds</li>
                  <li>Under-eye hollows</li>
                  <li>Jawline definition</li>
                </ul>
              </div>
            </div>
            <div>
              <img
                src="/lovable-uploads/24d3003c-8f4f-428f-9d21-2454d7ad7703.png"
                alt="Dermal Fillers Treatment"
                className="w-full h-[500px] object-cover rounded-lg shadow-lg mb-6"
              />
              <div className="bg-muted p-6 rounded-lg">
                <h3 className="text-xl font-semibold mb-4">What to Expect</h3>
                <ul className="space-y-3 text-gray-700">
                  <li>• Consultation to discuss your goals</li>
                  <li>• Custom treatment plan</li>
                  <li>• Minimal downtime</li>
                  <li>• Results visible immediately</li>
                  <li>• Effects last 6-18 months</li>
                </ul>
              </div>
            </div>
          </div>
          <div className="text-center">
            <a
              href="https://na02.patientnow.com/a/EVOLVEDYOU"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-block bg-primary text-white px-8 py-3 rounded-full text-lg hover:bg-primary/90 transition-colors"
            >
              Book Your Consultation
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Fillers;